import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import { Col, Row, Table } from "reactstrap";
import {
  GET_RP_OVERUSE_CODE,
  GET_RP_OVERUSE_CODE_DATA,
} from "../../../helpers/url_api_constant";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import PropTypes from "prop-types";
import { SHIPPER_COLOR_LIST } from "../../../constants/constants";
import { contacts } from "../../../common/data/chat";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function OveruseByContactComponent(props) {
  //   console.log(props);
  const dispatch = useDispatch();
  const [shippers, setShippers] = useState([]);
  const [contactCount, setContactCount] = useState(0);
  const [overuseData, setOveruseData] = useState([]);
  const shipperColor = [...SHIPPER_COLOR_LIST];
  shipperColor.splice(0, 1);

  useEffect(() => {
    fetchData();
  }, [props.summaryReportPid]);
  useEffect(() => { }, [props.date]);

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  const fetchData = async () => {
    function compare(a, b) {
      if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
        return -1;
      }
      if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
        return 1;
      }
      return 0;
    }
    function compareArea(a, b) {
      if (a.OVERUSE_AREA < b.OVERUSE_AREA) {
        return -1;
      }
      if (a.OVERUSE_AREA > b.OVERUSE_AREA) {
        return 1;
      }
      return 0;
    }
    dispatch(loadingAction.showLoading());
    try {
      let [res1, res2] = await Promise.all([
        post(GET_RP_OVERUSE_CODE, {
          SUMMARYREPORT_PID:
            props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        }),
        post(GET_RP_OVERUSE_CODE_DATA, {
          SUMMARYREPORT_PID:
            props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        }),
      ]);

      let shipperList = res1.data.RPOversureShipperList.sort(compare).map(
        (item, index) => ({
          SHIPPER_NAME: item.OVERUSECODE_SHIPPER,
          SHIPPER_PID: item.OVERUSECODE_PID,
          PRIORITY_FLAG: item.OVERUSECODE_ORDER,
          PID: item.PID,
        })
      );

      shipperList = [
        ...new Map(shipperList.map(item => [item["PID"], item])).values(),
      ];

      let data = res2.data.rpOveruseCodeDataList.map(row => ({
        ...row,
        OVERUSE_ACTUAL: Math.round(row.OVERUSE_ACTUAL / 1000),
        OVERUSE_BOOKING: Math.round(row.OVERUSE_BOOKING / 1000),
        OVERUSE: row.OVERUSE_ACTUAL > row.OVERUSE_BOOKING ? Math.round(row.OVERUSE_ACTUAL / 1000) - Math.round(row.OVERUSE_BOOKING / 1000) : 0,
      }));
      shipperList = shipperList.map(item => {

        let dataByShipper = data.filter(obj => obj.OVERUSECODE_PID == item.PID);
        let contactList = [
          ...new Set(
            dataByShipper.map(item => item.OVERUSE_CONTACTCODE.trim())
          ),
        ].sort();
        let entry = dataByShipper
          .filter(item => item.OVERUSE_POINT.toLowerCase() == "entry")
          .sort(compare);
        let exit = dataByShipper
          .filter(item => item.OVERUSE_POINT.toLowerCase() == "exit")
          .sort(compare);

        let entryData = entry
          .sort(compare)
          .reduce((r, a, index) => {
            let prevData = r.find(row => row.OVERUSE_AREA == a.OVERUSE_AREA);
            if (prevData != undefined) {
              r.map(row => {
                if (row.OVERUSE_AREA == prevData.OVERUSE_AREA) {
                  row.data = [...row.data, a];
                }
                return row;
              });
            } else {
              r.push({
                OVERUSE_AREA: a.OVERUSE_AREA,
                data: [a],
                PRIORITY_FLAG: a.PRIORITY_FLAG,
              });
            }

            return r;
          }, [])
          .sort(compareArea);
        let tempEntryTotal = entry.sort(compare).reduce((r, a) => {
          r[a.OVERUSE_CONTACTCODE.trim()] = [
            ...(r[a.OVERUSE_CONTACTCODE.trim()] || []),
            a,
          ];
          return r;
        }, {});
        let entryTotal = [];
        Object.keys(tempEntryTotal).map(key => {
          let temp = tempEntryTotal[key].reduce(
            (total, row) => {
              total.OVERUSE_BOOKING =
                total.OVERUSE_BOOKING + row.OVERUSE_BOOKING;
              total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL;
              total.OVERUSE = total.OVERUSE + row.OVERUSE;
              total.PRIORITY_FLAG =
                tempEntryTotal[key][0].OVERUSE_CONTACTCODE.trim();
              return total;
            },
            {
              OVERUSE_BOOKING: 0,
              OVERUSE_ACTUAL: 0,
              OVERUSE: 0,
              PRIORITY_FLAG: 0,
            }
          );
          entryTotal.push(temp);
        });
        if (entryTotal.length != contactList.length) {
          contactList.sort().map(row => {
            if (!entryTotal.some(obj => obj.PRIORITY_FLAG == row)) {
              entryTotal.push({
                OVERUSE_BOOKING: 0,
                OVERUSE_ACTUAL: 0,
                OVERUSE: 0,
                PRIORITY_FLAG: row,
              });
            }
          });
        }
        // console.log(entryTotal,contactList)
        let exitData = exit
          .sort(compare)
          .reduce((r, a, index) => {
            let prevData = r.find(row => row.OVERUSE_AREA == a.OVERUSE_AREA);
            if (prevData != undefined) {
              r.map(row => {
                if (row.OVERUSE_AREA == prevData.OVERUSE_AREA) {
                  row.data = [...row.data, a];
                }
                return row;
              });
            } else {
              r.push({
                OVERUSE_AREA: a.OVERUSE_AREA,
                data: [a],
                PRIORITY_FLAG: a.PRIORITY_FLAG,
              });
            }

            return r;
          }, [])
          .sort(compareArea);
        let tempExitTotal = exit.sort(compare).reduce((r, a) => {
          r[a.OVERUSE_CONTACTCODE.trim()] = [
            ...(r[a.OVERUSE_CONTACTCODE.trim()] || []),
            a,
          ];
          return r;
        }, {});
        let exitTotal = [];
        Object.keys(tempExitTotal).map(key => {
          let temp = tempExitTotal[key].reduce(
            (total, row) => {
              total.OVERUSE_BOOKING =
                total.OVERUSE_BOOKING + row.OVERUSE_BOOKING;
              total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL;
              total.OVERUSE = total.OVERUSE + row.OVERUSE;
              total.PRIORITY_FLAG =
                tempExitTotal[key][0].OVERUSE_CONTACTCODE.trim();
              return total;
            },
            {
              OVERUSE_BOOKING: 0,
              OVERUSE_ACTUAL: 0,
              OVERUSE: 0,
              PRIORITY_FLAG: 0,
            }
          );
          exitTotal.push(temp);
        });
        if (exitTotal.length != contactList.length) {
          contactList.sort().map(row => {
            if (!exitTotal.some(obj => obj.PRIORITY_FLAG == row)) {
              exitTotal.push({
                OVERUSE_BOOKING: 0,
                OVERUSE_ACTUAL: 0,
                OVERUSE: 0,
                PRIORITY_FLAG: row,
              });
            }
          });
        }

        // console.log(exitData)
        return {
          ...item,
          data: dataByShipper,
          contacts: contactList,
          entry: entryData,
          entryTotal: entryTotal,
          exit: exitData,
          exitTotal: exitTotal,
        };
      });

      let contactCountList = shipperList?.map(item => item?.contacts?.length);

      let contactCountMax = 0;
      if (contactCountList?.length)
        contactCountMax = Math?.max(...contactCountList);
      setContactCount(contactCountMax);

      setOveruseData(shipperList);
    } catch (error) {
      dispatch(messageAction?.showMessage(error.message));
    }
    dispatch(loadingAction?.hideLoading());
  };

  const renderSubColumn = (data, shipperIndex) => {
    // console.log(data)
    const RowByData = () => {
      return data.contacts
        .filter(contact => contact != "")
        .map((contacts, index) => {
          return (
            <React.Fragment key={index.toString()}>
              <th
                style={{
                  backgroundColor: shipperColor[shipperIndex],
                  color: "#FFFFFF",
                  // backgroundColor: index % 2 == 0 ? "#5868b785" : "#667eef85",
                  // color: "rgb(63, 145, 255)",
                  textAlign: "center",
                  width: "20px",
                  fontSize: "10px",
                }}
              >
                Booking
              </th>
              <th
                style={{
                  backgroundColor: shipperColor[shipperIndex],
                  color: "#FFFFFF",
                  // backgroundColor: index % 2 == 0 ? "#5868b785" : "#667eef85",
                  // color: "rgb(63, 145, 255)",
                  textAlign: "center",
                  width: "20px",
                  fontSize: "10px",
                }}
              >
                Actual
              </th>
              <th
                style={{
                  backgroundColor: shipperColor[shipperIndex],
                  color: "#FFFFFF",
                  // backgroundColor: index % 2 == 0 ? "#5868b785" : "#667eef85",
                  // color: "rgb(63, 145, 255)",
                  textAlign: "center",
                  width: "20px",
                  fontSize: "10px",
                }}
              >
                Overuse
              </th>
            </React.Fragment>
          );
        });
    };
    const RowByDummy = () => {
      let dummyList = [];
      if (
        contactCount != data.contacts.filter(contact => contact != "").length
      ) {
        let diff =
          contactCount - data.contacts.filter(contact => contact != "").length;
        // console.log(diff)
        for (let i = 0; i < diff; i++) {
          dummyList.push(i);
        }
      }
      return dummyList.map((contacts, index) => {
        return (
          <React.Fragment key={index.toString()}>
            <th
              style={{
                backgroundColor: shipperColor[shipperIndex],
                color: "#FFFFFFF",
                textAlign: "center",
                width: "20px",
                fontSize: "10px",
              }}
            ></th>
            <th
              style={{
                backgroundColor: shipperColor[shipperIndex],
                color: "#FFFFFFF",
                textAlign: "center",
                width: "20px",
                fontSize: "10px",
              }}
            ></th>
            <th
              style={{
                backgroundColor: shipperColor[shipperIndex],
                color: "#FFFFFFF",
                textAlign: "center",
                width: "20px",
                fontSize: "10px",
              }}
            ></th>
          </React.Fragment>
        );
      });
    };
    return (
      <>
        <RowByData />
        <RowByDummy />
      </>
    );
  };

  const renderTotalByRow = (data, item) => {
    let totalBooking = 0;
    let totalActual = 0;
    let total = 0;
    data.map((value, index) => {
      totalBooking += value.OVERUSE_BOOKING;
      totalActual += value.OVERUSE_ACTUAL;
      total += value.OVERUSE;
    });

    const Total = () => {
      return data
        .sort((a, b) =>
          a.PRIORITY_FLAG > b.PRIORITY_FLAG
            ? 1
            : b.PRIORITY_FLAG > a.PRIORITY_FLAG
              ? -1
              : 0
        )
        .map((value, index) => {
          return (
            <React.Fragment key={index.toString()}>
              <td>
                <p>{numberFormat(value.OVERUSE_BOOKING, 0)}</p>
              </td>
              <td>
                <p>{numberFormat(value.OVERUSE_ACTUAL, 0)}</p>
              </td>
              <td
                style={{
                  ...((value.OVERUSE).toFixed(0) > 0 && { color: "#FF4545" }),
                }}
              >
                <p>{numberFormat(value.OVERUSE, 0)}</p>
              </td>
              {/* rgb(240, 20, 6) */}
            </React.Fragment>
          );
        });
    };
    const RowByDummy = () => {
      let dummyList = [];
      // console.log(item.contacts.length)
      // for(let i =1; item.contacts.length>i;i++){

      //   dummyList.push("");
      // }

      if (contactCount != item.contacts.filter(m => m != "").length) {
        // console.log(item.contact)
        let diff = contactCount - item.contacts.filter(m => m != "").length;
        for (let i = 0; i < diff; i++) {
          dummyList.push(i);
        }
      }
      return dummyList.map((contacts, index) => {
        return (
          <React.Fragment key={index.toString()}>
            <td></td>
            <td></td>
            <td></td>
          </React.Fragment>
        );
      });
    };
    return (
      <>
        <Total />
        <RowByDummy />
        <td>
          <p>{numberFormat(totalBooking, 0)}</p>
        </td>
        <td>
          <p>{numberFormat(totalActual, 0)}</p>
        </td>
        <td style={{ ...((total).toFixed(0) > 0 && { color: "#FF4545" }) }}>
          <p>{numberFormat(total, 0)}</p>
        </td>
        {/* rgb(240, 20, 6) */}
      </>
    );
  };
  const DummyContact = (item, shipperIndex) => {
    let dummyList = [];
    if (contactCount != item.contacts.filter(m => m != "").length) {
      // console.log('tess')
      let diff = contactCount - item.contacts.filter(m => m != "").length;
      for (let i = 0; i < diff; i++) {
        dummyList.push(i);
      }
    }
    return dummyList.map((dummy, index) => {
      return (
        <React.Fragment key={index.toString()}>
          <th
            colSpan={3}
            style={{
              // backgroundColor: "#556ee678",
              // color: "rgb(63, 145, 255)",
              backgroundColor: shipperColor[shipperIndex],
              color: "#FFFFFF",
              textAlign: "center",
              fontSize: "10px",
            }}
          ></th>
        </React.Fragment>
      );
    });
  };
  const DummyData = item => {
    let dummyList = [];
    // console.log(contactCount,item)
    if (contactCount != item.length) {
      let diff = contactCount - item.length;
      for (let i = 0; i < diff; i++) {
        dummyList.push(i);
      }
    }
    return dummyList.map((dummy, index) => {
      return (
        <React.Fragment key={index.toString()}>
          <td></td>
          <td></td>
          <td></td>
        </React.Fragment>
      );
    });
  };
  const OveruseByContact = (data, contacts) =>
    contacts.map((contact, index) => {
      let dataByContact = data.find(obj => obj.OVERUSE_CONTACTCODE == contact);
      // console.log(dataByContact)
      if (dataByContact) {
        return (
          <React.Fragment key={dataByContact.PID}>
            <td>
              <p>{numberFormat(dataByContact.OVERUSE_BOOKING, 0)}</p>
              {/* <p>{numberFormat(dataByContact.OVERUSE_BOOKING, 0)}</p> */}
            </td>
            <td>
              <p>{numberFormat(dataByContact.OVERUSE_ACTUAL, 0)}</p>
              {/* <p>{numberFormat(dataByContact.OVERUSE_ACTUAL, 0)}</p> */}
            </td>
            <td
              style={{
                ...((dataByContact.OVERUSE) > 0 && {
                  color: "#FF4545",
                }),
              }}
            >
              {/* rgb(240, 20, 6) */}
              <p>{numberFormat(dataByContact.OVERUSE, 0)}</p>
              {/* <p>{numberFormat(((dataByContact.OVERUSE_ACTUAL/1000).toFixed(0)-(dataByContact.OVERUSE_BOOKING/1000).toFixed(0)), 0)}</p> */}
            </td>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment key={index.toString()}>
            <td></td>
            <td></td>
            <td></td>
          </React.Fragment>
        );
      }
    });

  const renderOveruseData = (data, contact) => {

    let newContact = [...contact]
  
    if(newContact.length<contactCount){
  for (let i = newContact.length; contactCount != i ; i++) {

      newContact.push("");
    }
    }
  

    let totalBooking = 0;
    let totalActual = 0;
    let total = 0;
    data = data.sort((a, b) =>
      a.OVERUSE_CONTACTCODE > b.OVERUSE_CONTACTCODE
        ? 1
        : b.OVERUSE_CONTACTCODE > a.OVERUSE_CONTACTCODE
          ? -1
          : 0
    );
    data.map(value => {

      totalBooking += value.OVERUSE_BOOKING;
      totalActual += value.OVERUSE_ACTUAL;;
      total += value.OVERUSE;

    });
    // console.log(data,contact)
    return (
      <React.Fragment>
        {OveruseByContact(data, newContact)}

        <td>
          <p>{numberFormat(totalBooking, 0)}</p>
        </td>
        <td>
          <p>{numberFormat(totalActual, 0)}</p>
        </td>
        <td
          style={{ ...((total) > 0 && { color: "#FF4545" }) }}
        // rgb(240, 20, 6)
        >
          <p>{numberFormat(total, 0)}</p>
        </td>
      </React.Fragment>
    );
  };
  return (
    <Row className="mt-3">
      <Col lg="12">
        <div className="table-responsive">
          <Table className="table table-bordered mb-3">
            {overuseData.map((item, shipperIndex) => {
              return (
                <React.Fragment key={item.SHIPPER_NAME}>
                  <thead>
                    <tr>
                      <th
                        colSpan={contactCount * 3 + 4}
                        style={{
                          backgroundColor: shipperColor[shipperIndex],
                          color: "#FFFFFF",
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        {item.SHIPPER_NAME}
                      </th>
                    </tr>
                    <tr>
                      <th
                        rowSpan={3}
                        style={{
                          backgroundColor: shipperColor[shipperIndex],
                          backgroundColor: shipperColor[shipperIndex],
                          color: "#FFFFFF",
                          // backgroundColor: "#556ee678",
                          // color: "rgb(63, 145, 255)",
                          textAlign: "center",
                          fontSize: "10px",
                        }}
                      >
                        Area
                      </th>
                    </tr>
                    <tr>
                      {item.contacts
                        .filter(contact => contact != "")
                        .map((contact, index) => {
                          return (
                            <th
                              key={index.toString()}
                              colSpan={3}
                              style={{
                                backgroundColor: shipperColor[shipperIndex],
                                // index % 2 == 0 ? "#5868b785" : "#667eef85",
                                color: "#FFFFFF",
                                // color: "rgb(63, 145, 255)",
                                textAlign: "center",
                                fontSize: "10px",
                              }}
                            >
                              {contact}
                            </th>
                          );
                        })}
                      {DummyContact(item, shipperIndex)}
                      <th
                        colSpan={3}
                        style={{
                          backgroundColor: shipperColor[shipperIndex],
                          color: "#FFFFFF",
                          // backgroundColor: "#556ee678",
                          // color: "rgb(63, 145, 255)",
                          textAlign: "center",
                          fontSize: "10px",
                        }}
                      >
                        Total
                      </th>
                    </tr>
                    <tr>
                      {renderSubColumn(item, shipperIndex)}
                      <th
                        style={{
                          backgroundColor: shipperColor[shipperIndex],
                          color: "#FFFFFF",
                          // backgroundColor: "#556ee678",
                          // color: "rgb(63, 145, 255)",
                          textAlign: "center",
                          width: "20px",
                          fontSize: "10px",
                        }}
                      >
                        Booking
                      </th>
                      <th
                        style={{
                          backgroundColor: shipperColor[shipperIndex],
                          color: "#FFFFFF",
                          // backgroundColor: "#556ee678",
                          // color: "rgb(63, 145, 255)",
                          textAlign: "center",
                          width: "20px",
                          fontSize: "10px",
                        }}
                      >
                        Actual
                      </th>
                      <th
                        style={{
                          backgroundColor: shipperColor[shipperIndex],
                          color: "#FFFFFF",
                          // backgroundColor: "#556ee678",
                          // color: "rgb(63, 145, 255)",
                          textAlign: "center",
                          width: "20px",
                          fontSize: "10px",
                        }}
                      >
                        Overuse
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    style={{
                      color: "#FFFFFF",
                      textAlign: "center",
                      borderBottom: "10px solid #22314B",
                    }}
                  >
                    {item.entry.map(obj => {
                      let totalBooking = 0;
                      let totalActual = 0;
                      let total = 0;
                      return (
                        <tr key={obj.OVERUSE_AREA}>
                          <td style={{ width: "10px" }}>{obj.OVERUSE_AREA}</td>
                          {renderOveruseData(obj.data, item.contacts)}
                        </tr>
                      );
                    })}

                    <tr style={{ backgroundColor: "#556ee630" }}>
                      <td>Total</td>
                      {renderTotalByRow(item.entryTotal, item)}
                    </tr>
                    {item.exit.map(obj => {
                      return (
                        <tr key={obj.OVERUSE_AREA}>
                          <td style={{ width: "10px" }}>{obj.OVERUSE_AREA}</td>
                          {renderOveruseData(obj.data, item.contacts)}
                        </tr>
                      );
                    })}
                    <tr style={{ backgroundColor: "#556ee630" }}>
                      <td>Total</td>
                      {renderTotalByRow(item.exitTotal, item)}
                    </tr>
                  </tbody>
                </React.Fragment>
              );
            })}
          </Table>
        </div>
      </Col>
    </Row>
  );
}

OveruseByContactComponent.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default OveruseByContactComponent;
